export default {
  // Header
  "cs.header.badge": "CyberSOC 24/7",
  "cs.header.back": "Regresar",
  "cs.header.active": "SOC Activo 24/7",

  // Hero slides
  "cs.hero.slide1.tag": "Centro de Operaciones",
  "cs.hero.slide1.title": "El Escudo Digital de",
  "cs.hero.slide1.highlight": "tu Empresa",
  "cs.hero.slide1.subtitle": "Nuestro CyberSOC opera 24/7/365 con analistas certificados, tecnologia de punta y procesos validados internacionalmente para proteger tu organizacion.",
  "cs.hero.slide1.cta": "Ver Dashboard en Vivo",

  "cs.hero.slide2.tag": "Threat Intelligence",
  "cs.hero.slide2.title": "Inteligencia Anticipada",
  "cs.hero.slide2.highlight": "contra Amenazas",
  "cs.hero.slide2.subtitle": "Monitoreamos dark web, foros underground y fuentes OSINT globales para anticipar ataques dirigidos horas o dias antes de que ocurran.",
  "cs.hero.slide2.cta": "Conocer mas",

  "cs.hero.slide3.tag": "Respuesta a Incidentes",
  "cs.hero.slide3.title": "Respuesta en",
  "cs.hero.slide3.highlight": "Menos de 5 Minutos",
  "cs.hero.slide3.subtitle": "Playbooks automatizados y equipos de respuesta activos listos para contener y neutralizar incidentes en tiempo record con zero downtime.",
  "cs.hero.slide3.cta": "Ver capacidades",

  "cs.hero.panel.title": "Estado del SOC en vivo",
  "cs.hero.panel.threats": "Amenazas detectadas",
  "cs.hero.panel.blocked": "Incidentes bloqueados",
  "cs.hero.panel.response": "Tiempo de respuesta",
  "cs.hero.panel.uptime": "Disponibilidad SOC",

  "cs.hero.backHome": "Volver al Inicio",

  // Dashboard
  "cs.dashboard.tag": "Monitoreo en tiempo real",
  "cs.dashboard.title": "CyberSOC",
  "cs.dashboard.highlight": "Dashboard",
  "cs.dashboard.subtitle": "Metricas operativas actualizadas en tiempo real desde nuestros centros de seguridad activos 24/7",

  "cs.dashboard.m1.label": "Amenazas detectadas hoy",
  "cs.dashboard.m2.label": "Incidentes bloqueados",
  "cs.dashboard.m3.label": "Endpoints monitoreados",
  "cs.dashboard.m4.label": "Tiempo de respuesta",

  "cs.dashboard.radar.title": "Threat Radar",
  "cs.dashboard.radar.active": "Activo",
  "cs.dashboard.radar.critical": "Criticos",
  "cs.dashboard.radar.high": "Altos",
  "cs.dashboard.radar.medium": "Medios",

  "cs.dashboard.feed.title": "Live Threat Feed",
  "cs.dashboard.feed.updating": "Actualizando cada 2s",

  // Features
  "cs.features.tag": "Servicios",
  "cs.features.title": "Capacidades del",
  "cs.features.highlight": "CyberSOC",
  "cs.features.subtitle": "Un centro de operaciones de clase mundial con tecnologia de punta y procesos certificados",

  "cs.features.f1.title": "Deteccion 24/7",
  "cs.features.f1.desc": "Monitoreo continuo de tu infraestructura con sensores distribuidos en multiples capas de red, endpoint y cloud.",
  "cs.features.f1.stat": "99.97%",
  "cs.features.f1.statLabel": "Uptime SOC",

  "cs.features.f2.title": "Respuesta a Incidentes",
  "cs.features.f2.desc": "Equipos de respuesta listos para actuar en menos de 5 minutos con protocolos establecidos y playbooks automatizados.",
  "cs.features.f2.stat": "< 5 min",
  "cs.features.f2.statLabel": "MTTR promedio",

  "cs.features.f3.title": "Threat Hunting",
  "cs.features.f3.desc": "Busqueda proactiva de amenazas avanzadas que evaden deteccion tradicional con analisis de comportamiento y ML.",
  "cs.features.f3.stat": "+200",
  "cs.features.f3.statLabel": "IoC diarios",

  "cs.features.f4.title": "Ciberinteligencia",
  "cs.features.f4.desc": "Monitoreo de dark web, foros de hackers y fuentes de inteligencia para anticipar ataques dirigidos a tu industria.",
  "cs.features.f4.stat": "5 Paises",
  "cs.features.f4.statLabel": "Fuentes OSINT",

  "cs.features.f5.title": "Endpoint Detection",
  "cs.features.f5.desc": "EDR/XDR avanzado con correlacion de eventos, analisis forense remoto y contencion automatica de amenazas.",
  "cs.features.f5.stat": "12K+",
  "cs.features.f5.statLabel": "Endpoints",

  "cs.features.f6.title": "Cloud Security",
  "cs.features.f6.desc": "Proteccion continua de cargas de trabajo en AWS, Azure y GCP con deteccion de configuraciones inseguras.",
  "cs.features.f6.stat": "Multi-Cloud",
  "cs.features.f6.statLabel": "Cobertura",

  // Cómo trabajamos
  "cs.process.tag": "Metodología",
  "cs.process.title": "Cómo",
  "cs.process.highlight": "trabajamos",
  "cs.process.subtitle": "Un proceso de respuesta probado y auditado, diseñado para detectar, contener y neutralizar amenazas en el menor tiempo posible.",
  "cs.process.step1.title": "Onboarding y diagnóstico",
  "cs.process.step1.desc": "Evaluamos tu infraestructura, inventariamos los activos críticos y desplegamos los sensores del SOC en tu entorno.",
  "cs.process.step1.meta": "Días 1-3",
  "cs.process.step2.title": "Monitoreo continuo 24/7",
  "cs.process.step2.desc": "Vigilamos eventos de red, endpoint, cloud e identidad con correlación inteligente los 365 días del año.",
  "cs.process.step2.meta": "24/7/365",
  "cs.process.step3.title": "Detección y análisis",
  "cs.process.step3.desc": "Analistas certificados validan cada alerta, descartan falsos positivos y clasifican el nivel de riesgo real.",
  "cs.process.step3.meta": "MTTD < 1 min",
  "cs.process.step4.title": "Respuesta y contención",
  "cs.process.step4.desc": "Activamos playbooks automatizados y aislamos la amenaza antes de que impacte tus operaciones.",
  "cs.process.step4.meta": "MTTR < 5 min",
  "cs.process.step5.title": "Reporte y mejora continua",
  "cs.process.step5.desc": "Entregamos informes ejecutivos y técnicos con acciones de hardening para fortalecer tu postura de seguridad.",
  "cs.process.step5.meta": "Reportes semanales",
  "cs.process.step1.statUnit": "días",
  "cs.process.step2.statUnit": "días/año",
  "cs.process.step3.statUnit": "seg (MTTD)",
  "cs.process.step4.statUnit": "min (MTTR)",
  "cs.process.step5.statUnit": "reportes/año",

  // Centro / Instalaciones
  "cs.centro.tag": "Nuestro centro",
  "cs.centro.title": "Instalaciones de clase mundial para la",
  "cs.centro.highlight": "ciberseguridad",
  "cs.centro.subtitle": "Diseñadas para la protección, la investigación y la formación: un ecosistema donde convergen tecnología, talento humano y metodología probada.",
  "cs.centro.cta": "Ver capacidades",
  "cs.centro.detail": "Ver detalle ampliado",
  "cs.centro.modal.features": "Capacidades clave",
  "cs.centro.modal.close": "Cerrar",
  "cs.centro.modal.ctaPrimary": "Ver capacidades",
  "cs.centro.modal.ctaSecondary": "Habla con un experto",

  // CTA
  "cs.cta.tag": "Activar proteccion",
  "cs.cta.title": "Protege tu empresa con el",
  "cs.cta.subtitle": "Un equipo de mas de 200 especialistas certificados listo para defender tu organizacion ahora mismo",
  "cs.cta.button": "Solicitar evaluacion gratuita",
  "cs.cta.homeButton": "Ver sitio principal",
};